import { formatAddress } from "@therms/web-js";
import { upperFirst } from "lodash-es";
import * as xlsx from "xlsx";
//#region src/modules/Events/shared/events-summary-download.ts
function getEventRecordIds(events, formsById) {
	const recordIdsById = {};
	events.forEach((event) => {
		const dispo = event.primaryDisposition;
		if (!dispo?.fields) return;
		const fieldsById = formsById?.[dispo.formId]?.formBuilder?.fieldsById;
		if (!fieldsById) return;
		Object.keys(dispo.fields).forEach((fieldId) => {
			if (fieldsById[fieldId]?.type !== "record") return;
			const value = dispo.fields[fieldId];
			(Array.isArray(value) ? value : [value]).forEach((recordId) => {
				if (typeof recordId === "string" && recordId) recordIdsById[recordId] = recordId;
			});
		});
	});
	return Object.keys(recordIdsById);
}
function eventsSummaryDownload(events, deps, config) {
	const dispoFieldById = /* @__PURE__ */ new Map();
	const dispoColumnLabels = [];
	const seenColumnLabels = /* @__PURE__ */ new Set();
	events.forEach((event) => {
		const dispo = event.primaryDisposition;
		if (!dispo?.fields) return;
		const fieldsById = deps.formsById?.[dispo.formId]?.formBuilder?.fieldsById;
		Object.keys(dispo.fields).forEach((fieldId) => {
			if (!dispoFieldById.has(fieldId)) {
				const field = fieldsById?.[fieldId];
				const options = field?.options;
				dispoFieldById.set(fieldId, {
					label: options?.displayLabel || fieldId,
					type: field?.type
				});
			}
			const label = dispoFieldById.get(fieldId).label;
			if (!seenColumnLabels.has(label)) {
				seenColumnLabels.add(label);
				dispoColumnLabels.push(label);
			}
		});
	});
	const arrayOfArrays = [[
		"ID",
		"Location",
		"Address",
		"Latitude",
		"Longitude",
		"Event Type",
		"State",
		"Time",
		"Close Time",
		"Activity Types",
		"Assigned Users",
		...dispoColumnLabels.map((label) => `Dispo - ${label}`)
	]];
	events.forEach((event) => {
		const dispoFields = event.primaryDisposition?.fields;
		const dispoValuesByLabel = /* @__PURE__ */ new Map();
		const addDispoValue = (label, formatted) => {
			if (!formatted) return;
			const existing = dispoValuesByLabel.get(label);
			dispoValuesByLabel.set(label, existing ? `${existing}, ${formatted}` : formatted);
		};
		if (dispoFields) Object.keys(dispoFields).forEach((fieldId) => {
			const field = dispoFieldById.get(fieldId);
			if (!field) return;
			const value = dispoFields[fieldId];
			if (field.type === "datetime") {
				if (typeof value === "string") dispoValuesByLabel.set(field.label, new Date(value));
				return;
			}
			let formatted;
			if (value === void 0 || value === null) formatted = "";
			else if (field.type === "activitytypes" && Array.isArray(value)) formatted = value.map((activityType) => activityType?.title || "").join(", ");
			else if (field.type === "record") formatted = (Array.isArray(value) ? value : [value]).map((recordId) => {
				const record = deps.recordsById[recordId];
				if (!record) return "";
				return `${record.title} (${upperFirst(record.type)})`;
			}).filter(Boolean).join(", ");
			else if (field.type === "signature") {
				if (!value?.d) formatted = value?.signerName ? `${value.signerName} (no signature)` : "No signature";
				else formatted = value.signerName ? `Signed by ${value.signerName}` : "Signed";
			} else if (typeof value === "object") formatted = JSON.stringify(value);
			else formatted = String(value);
			addDispoValue(field.label, formatted);
		});
		arrayOfArrays.push([
			event.idLabel || "",
			event.locationId ? deps.locationsById[event.locationId]?.name : "",
			deps.locationsById[event.locationId]?.address ? formatAddress(deps.locationsById[event.locationId]?.address, true) : "",
			event.locationGeo?.lat ?? "",
			event.locationGeo?.lng ?? "",
			event.eventType.name,
			upperFirst(event.state),
			new Date(event.date),
			event.state === "closed" && event.stateDate ? new Date(event.stateDate) : "",
			event.activityTypeTags?.map((activityType) => activityType.title).join(", ") || "",
			event.assignedUsers?.reduce((acc, assignedUser) => {
				const user = deps.usersById[assignedUser.userId];
				if (user) acc.push(`${user.displayName}${user.idNumber ? ` (${user.idNumber})` : ""}`);
				return acc;
			}, []).join(", ") || "",
			...dispoColumnLabels.map((label) => dispoValuesByLabel.get(label) ?? "")
		]);
	});
	const ws = xlsx.utils.aoa_to_sheet(arrayOfArrays, {
		cellDates: true,
		dateNF: "yyyy-mm-dd hh:mm:ss"
	});
	const wb = xlsx.utils.book_new();
	xlsx.utils.book_append_sheet(wb, ws, "Summary");
	if (config.format === "csv") xlsx.writeFile(wb, `${config.fileName}.csv`, { bookType: "csv" });
	else xlsx.writeFile(wb, `${config.fileName}.xlsx`, { bookType: "xlsx" });
}
//#endregion
export { eventsSummaryDownload, getEventRecordIds };

//# sourceMappingURL=events-summary-download.js.map